<!-- start page title -->
<app-pagetitle title="Dashboard" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<!-- Verificação de Acesso -->
<!-- <div *ngIf="!temAcessoAoDashboard">
  <app-no-access></app-no-access>
</div> -->

<!-- <div *ngIf="temAcessoAoDashboard"> -->
  <!-- Conteúdo do Dashboard (apenas para usuários com permissão) -->

   <!-- Mensagem de Erro -->
   <div *ngIf="error" class="alert alert-danger mb-4" role="alert">
    <i class="fas fa-exclamation-triangle me-2"></i>
    {{ error }}
  </div>

 
  
  <!-- Cards de KPIs - Call Center e Vendas -->
  <div class="row mb-1" >
    <!-- Coluna Esquerda - KPIs -->
    <div class="col-6" *ngIf="temAcessoAoDashboard">
      <div class="row">
        <!-- Primeira Linha - 2 KPIs -->
        <div class="col-6 mb-1">
          <div class="card border-success">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <h6 class="text-muted mb-2">Total Qualificados</h6>
                  <h3 class="mb-0">{{ kpiTotalQualificados | number }}</h3>
                </div>
                <div class="flex-shrink-0">
                  <div class="avatar-sm">
                    <span class="avatar-title bg-success-subtle text-success rounded-circle fs-2">
                      <i class="fas fa-check-circle"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 mb-1">
          <div class="card border-primary">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <h6 class="text-muted mb-2">Total de Contatos</h6>
                  <h3 class="mb-0">{{ kpiTotalContatos | number }}</h3>
                </div>
                <div class="flex-shrink-0">
                  <div class="avatar-sm">
                    <span class="avatar-title bg-primary-subtle text-primary rounded-circle fs-2">
                      <i class="fas fa-users"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Segunda Linha - 2 KPIs -->
        <div class="col-6 mb-1">
          <div class="card border-primary">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <h6 class="text-muted mb-2">Total de Projetos</h6>
                  <h3 class="mb-0">{{ kpiTotalProjetos | number }}</h3>
                </div>
                <div class="flex-shrink-0">
                  <div class="avatar-sm">
                    <span class="avatar-title bg-primary-subtle text-primary rounded-circle fs-2">
                      <i class="fas fa-project-diagram"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 mb-1">
          <div class="card border-success">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <h6 class="text-muted mb-2">Total de Receita</h6>
                  <h3 class="mb-0">R$ {{ kpiTotalReceita | number:'1.2-2' }}</h3>
                </div>
                <div class="flex-shrink-0">
                  <div class="avatar-sm">
                    <span class="avatar-title bg-success-subtle text-success rounded-circle fs-2">
                      <i class="fas fa-dollar-sign"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <!-- Coluna Direita - Agenda de Eventos -->
    <div class="col-6">
        <div class="card">
            <div class="card-header p-1 ps-2 pt-2">
                <h5 class="card-title">Próximos Eventos</h5>
            </div>
            <div class="card-body px-0" style="max-height: 183px; overflow-y: auto;">
                <div class="table-responsive px-3">
                    <table class="table align-middle table-nowrap table-borderless">
                        <tbody>
                            @for (data of transactionsAll; track $index) {
                            <tr>
                                <td style="width: 50px;">
                                    <div class="font-size-22 text-primary">
                                        <i class="bx bx-map-pin d-block"></i>
                                    </div>
                                </td>

                                <td>
                                    <div>
                                        <h5 class="font-size-14 mb-1">{{data.nomeFeira}}</h5>
                                        <!-- <p class="text-muted mb-0 font-size-12"></p> -->
                                    </div>
                                </td>

                                <td>
                                    <div class="text-end">
                                        <h5 class="font-size-14 mb-0">{{data.dataInicioFeira}}</h5>
                                        <p class="text-muted mb-0 font-size-12">De</p>
                                    </div>
                                </td>

                                <td>
                                    <div class="text-end">
                                        <h5 class="font-size-14 text-muted mb-0">{{data.dataFimFeira}}</h5>
                                        <p class="text-muted mb-0 font-size-12">Até</p>
                                    </div>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- end card -->
    
    </div>
  </div>

  <div *ngIf="temAcessoAoDashboard">
  <!-- Fim do conteúdo do Dashboard -->

  <!-- Filtros Globais -->
  <div class="card mb-4">
    <div class="card-header">
      <h5 class="card-title mb-0">
        <i class="fas fa-filter me-2"></i>
        Filtros do Dashboard
      </h5>
    </div>
    <div class="card-body">
      <form [formGroup]="filtroForm">
        <div class="row g-3">
          <div class="col-md-3">
            <label for="tipoPeriodo" class="form-label">Tipo de Período</label>
            <select class="form-select form-select-sm" id="tipoPeriodo" formControlName="tipoPeriodo">
              <option [ngValue]="1">Por Mês</option>
              <option [ngValue]="2">Por Ano</option>
              <!-- <option [ngValue]="3">Personalizado</option> -->
              <!-- <option [ngValue]="4">Todos</option> -->
            </select>
          </div>

          <div class="col-md-2" *ngIf="filtroForm.get('tipoPeriodo')?.value === 1">
            <label for="mes" class="form-label">Mês</label>
            <select class="form-select form-select-sm" id="mes" formControlName="mes">
              <option *ngFor="let mes of meses" [ngValue]="mes.value">{{ mes.label }}</option>
            </select>
          </div>

          <div class="col-md-2">
            <label for="ano" class="form-label">Ano</label>
            <input type="number" class="form-control form-control-sm" id="ano" formControlName="ano" min="2020"
              max="2100">
          </div>

          <div class="col-md-2" *ngIf="filtroForm.get('tipoPeriodo')?.value === 3">
            <label for="dataInicio" class="form-label">Data Início</label>
            <input type="date" class="form-control form-control-sm" id="dataInicio" formControlName="dataInicio">
          </div>

          <div class="col-md-2" *ngIf="filtroForm.get('tipoPeriodo')?.value === 3">
            <label for="dataFim" class="form-label">Data Fim</label>
            <input type="date" class="form-control form-control-sm" id="dataFim" formControlName="dataFim">
          </div>

          <!-- <div class="col-md-3">
          <label for="feiraId" class="form-label">Feira (Opcional)</label>
          <input type="text" class="form-control form-control-sm" id="feiraId" formControlName="feiraId" placeholder="ID da Feira">
        </div>

        <div class="col-md-3">
          <label for="clienteId" class="form-label">Cliente (Opcional)</label>
          <input type="text" class="form-control form-control-sm" id="clienteId" formControlName="clienteId" placeholder="ID do Cliente">
        </div> 

        <div class="col-md-3">
          <label for="listaId" class="form-label">Lista (Opcional)</label>
          <select class="form-select form-select-sm" id="listaId" formControlName="listaId">
            <option [ngValue]="null">Selecione uma lista</option>
            <option *ngFor="let lista of listas" [ngValue]="lista.id">{{ lista.nomeLista }}</option>
          </select>
        </div>

        
        <div class="col-md-3">
          <label for="atendente" class="form-label">Atendente (Opcional)</label>
          <input type="text" class="form-control form-control-sm" id="atendente" formControlName="atendente" placeholder="Nome do Atendente">
        </div> -->
        </div>
      </form>
    </div>
  </div>

  
  <!-- Abas de Gráficos -->
  <div class="card">
    <div class="card-body">
      <ul ngbNav #nav="ngbNav" [(activeId)]="activeTabId" (activeIdChange)="onTabChange($event)"
        class="nav-tabs nav-tabs-custom nav-justified">
        <!-- Aba Call Center (Padrão) -->
        <li [ngbNavItem]="1">
          <a ngbNavLink>
            <i class="fas fa-phone-alt me-2"></i>
            <span class="d-none d-sm-inline">Call Center</span>
          </a>
          <ng-template ngbNavContent>
            <app-dashboard-call-center #callCenterComponent [hideTitle]="true"
              [filtrosExternos]="filtros"></app-dashboard-call-center>

            <!-- Performance por Lista de Contatos Gerados -->
            <div class="row mt-1">
              <!-- Filtros específicos para Performance por Lista -->
              <div class="col-12 mb-3">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title mb-0">
                      <i class="fas fa-filter me-2"></i>
                      Filtros - Performance por Lista de Contatos Gerados
                    </h5>
                  </div>
                  <div class="card-body">
                    <form [formGroup]="filtroPerformanceListasForm">
                      <div class="row g-3">
                        <div class="col-md-2">
                          <label for="tipoPeriodoPerformance" class="form-label">Tipo de Período</label>
                          <select class="form-select form-select-sm" id="tipoPeriodoPerformance"
                            formControlName="tipoPeriodo">
                            <option [ngValue]="1">Por Mês</option>
                            <option [ngValue]="2">Por Ano</option>
                            <option [ngValue]="3">Personalizado</option>
                            <option [ngValue]="4">Todos</option>
                          </select>
                        </div>

                        <div class="col-md-2" *ngIf="filtroPerformanceListasForm.get('tipoPeriodo')?.value === 1">
                          <label for="mesPerformance" class="form-label">Mês</label>
                          <select class="form-select form-select-sm" id="mesPerformance" formControlName="mes">
                            <option *ngFor="let mes of meses" [ngValue]="mes.value">{{ mes.label }}</option>
                          </select>
                        </div>

                        <div class="col-md-2">
                          <label for="anoPerformance" class="form-label">Ano</label>
                          <input type="number" class="form-control form-control-sm" id="anoPerformance"
                            formControlName="ano" min="2020" max="2100">
                        </div>

                        <div class="col-md-2" *ngIf="filtroPerformanceListasForm.get('tipoPeriodo')?.value === 3">
                          <label for="dataInicioPerformance" class="form-label">Data Início</label>
                          <input type="date" class="form-control form-control-sm" id="dataInicioPerformance"
                            formControlName="dataInicio">
                        </div>

                        <div class="col-md-2" *ngIf="filtroPerformanceListasForm.get('tipoPeriodo')?.value === 3">
                          <label for="dataFimPerformance" class="form-label">Data Fim</label>
                          <input type="date" class="form-control form-control-sm" id="dataFimPerformance"
                            formControlName="dataFim">
                        </div>

                        <!-- <div class="col-md-2">
                          <label for="listaIdPerformance" class="form-label">Lista (Opcional)</label>
                          <select class="form-select form-select-sm" id="listaIdPerformance" formControlName="listaId">
                            <option [ngValue]="null">Todas as listas</option>
                            <option *ngFor="let lista of listas" [ngValue]="lista.id">{{ lista.nomeLista }}</option>
                          </select>
                        </div> -->

                        <!-- <div class="col-md-2">
                          <label for="feiraIdPerformance" class="form-label">Feira (Opcional)</label>
                          <select class="form-select form-select-sm" id="feiraIdPerformance" formControlName="feiraId">
                            <option [ngValue]="null">Todas as feiras</option>
                            <option *ngFor="let feira of feiras" [ngValue]="feira.id || feira.feiraId">{{ feira.nome }}</option>
                          </select>
                        </div> -->

                        <!-- <div class="col-md-2">
                          <label for="atendentePerformance" class="form-label">Atendente (Opcional)</label>
                          <input type="text" class="form-control form-control-sm" id="atendentePerformance"
                            formControlName="atendente" placeholder="Nome do atendente">
                        </div> -->

                        <div class="col-md-2 d-flex align-items-end">
                          <button type="button" class="btn btn-primary btn-sm w-100"
                            (click)="aplicarFiltrosPerformanceListas()">
                            <i class="fas fa-search me-1"></i>
                            Aplicar Filtros
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <!-- Mensagem quando não há dados - Logo abaixo do filtro -->
              <div
                *ngIf="!performanceListasData || !performanceListasData.listas || performanceListasData.listas.length === 0"
                class="col-12 mb-3">
                <div class="alert alert-info" role="alert">
                  <i class="fas fa-info-circle me-2"></i>
                  Nenhum dado encontrado para os filtros selecionados. Ajuste os filtros e clique em "Aplicar Filtros".
                </div>
              </div>

              <div
                *ngIf="performanceListasData && performanceListasData.listas && performanceListasData.listas.length > 0">
                <!-- Linha 1: Total de Contatos por Lista - OCULTO -->
                <!--
                <div class="row mb-3">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <h6 class="card-title mb-2">
                          Total de Contatos por Lista
                          <i class="fas fa-question-circle ms-1"
                            ngbTooltip="Visualize o total de contatos em cada lista de contatos gerados." placement="top"
                            style="cursor: help; font-size: 0.85rem;"></i>
                        </h6>
                        <div style="position: relative; height: 400px;">
                          <canvas id="performanceContatosChart"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                -->

                <!-- Linha 2: Qualificados vs Não Qualificados por Lista - OCULTO -->
                <!--
                <div class="row mb-3">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <h6 class="card-title mb-2">
                          Qualificados vs Não Qualificados por Lista
                          <i class="fas fa-question-circle ms-1"
                            ngbTooltip="Compare a quantidade de contatos qualificados e não qualificados em cada lista."
                            placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                        </h6>
                        <div style="position: relative; height: 400px;">
                          <canvas id="performanceQualificadosChart"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                -->

                <!-- Linha 3: Performance por Feira -->
                <div class="row mb-3" *ngIf="performanceFeirasData && performanceFeirasData.feiras && performanceFeirasData.feiras.length > 0">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <h6 class="card-title mb-2">
                          Performance por Feira
                          <i class="fas fa-question-circle ms-1"
                            ngbTooltip="Compare o aproveitamento de diferentes feiras. Visualize a quantidade de contatos qualificados, não qualificados e projetos gerados por feira."
                            placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                        </h6>
                        <div style="position: relative; height: 400px;">
                          <canvas id="performanceFeirasChart"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Linha 4: Mensagens por Dia e por Feira -->
                <div class="row mb-3" *ngIf="mensagensPorDiaFeiraData && mensagensPorDiaFeiraData.feiras && mensagensPorDiaFeiraData.feiras.length > 0">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <h6 class="card-title mb-2">
                          Mensagens por Dia e por Feira
                          <i class="fas fa-question-circle ms-1"
                            ngbTooltip="Visualize a evolução temporal das mensagens enviadas aos contatos gerados, separadas por feira. Cada feira é representada por uma linha no gráfico."
                            placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                        </h6>
                        <div style="position: relative; height: 400px;">
                          <canvas id="mensagensPorDiaFeiraChart"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Linha 5: Performance de Atendentes -->
                <div class="row mb-3" *ngIf="performanceAtendentesData && performanceAtendentesData.labels && performanceAtendentesData.labels.length > 0">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <h6 class="card-title mb-2">
                          Performance de Atendentes
                          <i class="fas fa-question-circle ms-1"
                            ngbTooltip="Compare a performance de cada atendente, incluindo total de mensagens enviadas e contatos qualificados. Permite identificar atendentes com maior volume de mensagens e maior taxa de qualificação."
                            placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                        </h6>
                        <div style="position: relative; height: 400px;">
                          <canvas id="performanceAtendentesChart"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </li>

        <!-- Aba Vendas -->
        <li [ngbNavItem]="2">
          <a ngbNavLink>
            <i class="fas fa-project-diagram me-2"></i>
            <span class="d-none d-sm-inline">Projetos</span>
          </a>
          <ng-template ngbNavContent>
            <!-- Loading -->
            <div *ngIf="isLoading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-2 text-muted">Carregando gráficos do dashboard...</p>
            </div>

            <!-- Gráficos de Vendas -->
            <div *ngIf="!isLoading" class="row">
              <!-- Linha 1: Gráficos Principais -->
              <div class="col-xl-6 col-lg-6 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Pipeline de Projetos
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Visualize a quantidade de projetos em cada status do pipeline. Use este gráfico para entender a distribuição de projetos e identificar gargalos no processo."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 320px;">
                      <canvas id="pipelineChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-6 col-lg-12 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Projetos por Status
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Visualize a distribuição de projetos por status atual (Em Andamento ou Concluído). Este gráfico mostra quais projetos estão em construção e quais já foram concluídos."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 300px;">
                      <canvas id="projetosPorStatusChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Linha 5: Projetos por Feira (largura total) -->
              <div class="col-12 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Projetos por Feira
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Visualize a distribuição de projetos por feira. Este gráfico mostra em quais feiras a empresa está presente e a quantidade de projetos em cada uma."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 300px;">
                      <canvas id="projetosPorFeiraChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Linha 6: Projetos Temporal -->
              <div class="col-12 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Projetos ao Longo do Tempo
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Acompanhe a evolução de projetos ao longo do tempo. Identifique períodos de maior atividade e tendências de criação de projetos."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 300px;">
                      <canvas id="projetosTemporalChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </li>

        <!-- Aba Financeiro -->
        <li [ngbNavItem]="3">
          <a ngbNavLink>
            <i class="fas fa-dollar-sign me-2"></i>
            <span class="d-none d-sm-inline">Financeiro</span>
          </a>
          <ng-template ngbNavContent>
            <!-- Loading -->
            <div *ngIf="isLoading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-2 text-muted">Carregando gráficos do dashboard...</p>
            </div>

            <!-- Gráficos de Orçamentos -->
            <div *ngIf="!isLoading" class="row">
              <!-- ========== GRÁFICOS BÁSICOS ========== -->
              <div class="col-12 mb-3">
                <h5 class="mb-3">
                  <i class="fas fa-chart-bar me-2"></i>
                  Gráficos Básicos
                </h5>
              </div>

              <!-- Linha 1: Orçamentos por Status e por Feira -->
              <div class="col-xl-6 col-lg-6 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Orçamentos por Status
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Visualize a distribuição de orçamentos por status (Orçando, Aprovado, Reprovado)."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 320px;">
                      <canvas id="orcamentosPorStatusChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Orçamentos por Feira
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Visualize a distribuição de orçamentos agrupados por feira."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 320px;">
                      <canvas id="orcamentosPorFeiraChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Linha 2: Orçamentos Temporal -->
              <div class="col-12 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Orçamentos ao Longo do Tempo
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Acompanhe a evolução temporal de orçamentos ao longo do tempo, mostrando quantidade e receita."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 300px;">
                      <canvas id="orcamentosTemporalChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ========== GRÁFICOS FINANCEIROS ========== -->
              <div class="col-12 mb-3 mt-4">
                <h5 class="mb-3">
                  <i class="fas fa-dollar-sign me-2"></i>
                  Gráficos Financeiros
                </h5>
              </div>

              <!-- Linha 3: Margem de Lucro e Custo vs Receita -->
              <div class="col-xl-6 col-lg-6 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Distribuição de Margem de Lucro
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Histograma mostrando a distribuição de orçamentos por faixas de percentual de margem de lucro."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 320px;">
                      <canvas id="margemLucroDistribuicaoChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Custo vs Receita
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Compara custos totais com receita por período, mostrando lucro bruto e margem de lucro."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 320px;">
                      <canvas id="custoVsReceitaChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Linha 4: Composição de Custos -->
              <div class="col-12 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Composição de Custos
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Stacked bar chart mostrando a composição detalhada de todos os componentes de custos e margens."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 350px;">
                      <canvas id="composicaoCustosChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Linha 5: Percentuais e Variação -->
              <div class="col-xl-6 col-lg-6 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Distribuição de Percentuais
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Mostra médias e medianas dos percentuais de orçamentos (margem, comissões, etc.)."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 320px;">
                      <canvas id="percentuaisChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Análise de Variação
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Histograma mostrando a distribuição de orçamentos por faixas de percentual de variação."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 320px;">
                      <canvas id="variacaoChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Linha 6: Receita por Metro Quadrado -->
              <div class="col-12 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Receita por Metro Quadrado
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Analisa eficiência de receita por área (m²) usando Comprimento e Largura."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 300px;">
                      <canvas id="receitaMetroQuadradoChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ========== GRÁFICOS DE PROCESSO ========== -->
              <div class="col-12 mb-3 mt-4">
                <h5 class="mb-3">
                  <i class="fas fa-cogs me-2"></i>
                  Gráficos de Processo
                </h5>
              </div>

              <!-- Linha 7: Envio de Email e Por Evento -->
              <div class="col-xl-6 col-lg-6 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Taxa de Envio de Orçamentos por Email
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Mostra a evolução temporal da taxa de envio de orçamentos por email."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 320px;">
                      <canvas id="orcamentosEnvioEmailChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="col-xl-6 col-lg-6 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Orçamentos por Período de Evento
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Agrupa orçamentos por período baseado em DataInicioEvento."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 320px;">
                      <canvas id="orcamentosPorEventoChart"></canvas>
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- Linha 8: Aprovação de Orçamentos -->
              <div class="col-xl-6 col-lg-6 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Aprovação de Orçamentos
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Pie chart mostrando a distribuição de aprovações e taxas de conversão."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 320px;">
                      <canvas id="aprovacaoOrcamentoChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Linha 9: Gráficos Financeiros Existentes (Status de Ordens e Receita) -->
              <!-- <div class="col-xl-6 col-lg-6 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Status de Ordens de Compra
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Visualize a distribuição de ordens de compra por status. Identifique quantas compras estão pendentes, concluídas ou canceladas para melhor gestão do processo de compras."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 320px;">
                      <canvas id="ordensChart"></canvas>
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- <div class="col-12 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      Receita ao Longo do Tempo
                      <i class="fas fa-question-circle ms-1"
                        ngbTooltip="Acompanhe a evolução da receita ao longo do tempo. Identifique tendências de crescimento, períodos de maior faturamento e sazonalidade do negócio."
                        placement="top" style="cursor: help; font-size: 0.85rem;"></i>
                    </h6>
                    <div style="position: relative; height: 300px;">
                      <canvas id="receitaChart"></canvas>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-3"></div>
    </div>
    <!-- Fim do conteúdo do Dashboard -->
  </div>
</div>